import EmailCaptureForm from 'marketing/components/EmailCaptureForm';
import '@99designs/common/jquery-plugins/tooltip';

document.addEventListener('DOMContentLoaded', () => {
    const categorySelect = document.querySelector('[data-category]');
    const bundlesField = document.querySelector('[data-bundles]');

    const websiteTypeField = document.querySelector('[data-website-type]');
    const websiteTypeOtherCheckbox = document.querySelector('[data-website-type-other-checkbox]');
    const websiteTypeOtherTextField = document.querySelector(
        '[data-website-type-other-text-field]'
    );
    const websiteProviderField = document.querySelector('[data-website-provider]');
    const websiteProviderSelect = document.querySelector('[data-website-provider-select]');
    const websiteProviderOtherTextField = document.querySelector(
        '[data-website-provider-other-text-field]'
    );
    const domainField = document.querySelector('[data-domain');

    categorySelect.addEventListener('change', e => {
        if (e.target.value === 'logo-design') {
            bundlesField.style.display = 'block';
        } else {
            bundlesField.style.display = 'none';
        }

        if (e.target.value === 'web-design') {
            domainField.style.display = 'block';
            websiteTypeField.style.display = 'block';
            websiteProviderField.style.display = 'block';
        } else {
            domainField.style.display = 'none';
            websiteTypeField.style.display = 'none';
            websiteProviderField.style.display = 'none';
        }
    });

    websiteTypeOtherCheckbox.addEventListener('change', () => {
        websiteTypeOtherTextField.style.display = websiteTypeOtherCheckbox.checked
            ? 'block'
            : 'none';
    });

    websiteProviderSelect.addEventListener('change', e => {
        websiteProviderOtherTextField.style.display = e.target.value === 'other' ? 'block' : 'none';
    });

    new EmailCaptureForm(
        document.querySelector('[data-email-capture-form="design_consultation_form"]'),
        {
            withRecaptcha: true,
        }
    );

    $('[data-tooltip]').tooltip();
});
